import React from 'react';
import { TripRequest, TripRequestStatus } from '@marageti/z4-sdk/lib/travel';
import { UserStatus } from '@marageti/z4-sdk/lib/auth';
import {
  PostponedAlert,
  VerifyUserAlert,
  OutsideReferralAlert,
  JunkAlert,
  DisabledTravelerAlert,
} from '../../components/trip-request-alerts';

const Alerts = ({
  handleJunk,
  handleReactivation,
  handleReenable,
  handleVerify,
  isReactivating,
  isReenabling,
  isVerifying,
  tripRequest,
}:
{
  handleJunk: () => void,
  handleReactivation: () => void,
  handleReenable: () => void,
  handleVerify: () => void,
  isReactivating: boolean,
  isReenabling: boolean,
  isVerifying: boolean,
  tripRequest: TripRequest,
}) => {
  switch (tripRequest.status) {
    case TripRequestStatus.PostponedStatus:
      return <PostponedAlert handleReactivation={handleReactivation} isReactivating={isReactivating} />;
    case TripRequestStatus.PendingStatus:
      if (tripRequest.travelers[0]?.userInfo[0]?.status === UserStatus.DISABLED) {
        return <DisabledTravelerAlert handleClick={handleReenable} isReenabling={isReenabling} />;
      }
      return <VerifyUserAlert handleVerify={handleVerify} loading={isVerifying} />;
    case TripRequestStatus.ReferredStatus:
      return <OutsideReferralAlert />;
    case TripRequestStatus.JunkStatus:
      return <JunkAlert handleClick={handleJunk} />;
    default:
      return null;
  }
};

export default Alerts;
